import { render } from "./AdminSideBarItem.vue?vue&type=template&id=7ea4bab3&scoped=true"
import script from "./AdminSideBarItem.vue?vue&type=script&lang=js"
export * from "./AdminSideBarItem.vue?vue&type=script&lang=js"

import "./AdminSideBarItem.vue?vue&type=style&index=0&id=7ea4bab3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea4bab3"]])

export default __exports__